import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { TypeConceptModel } from 'src/app/models/management/type-concept.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { TypeConceptTableModel } from 'src/app/models/tables/management/type-concept-table.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TypeConceptService {

  constructor(private _httpClient: HttpClient) {

  }

  createTypeConcept(typeConceptModel: TypeConceptModel): Observable<TypeConceptModel> {
    return this._httpClient.post<TypeConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.typeConcept.CreateTypeConcept}`,
      typeConceptModel);
  }

  deleteTypeConcept(typeConceptId: number): Observable<TypeConceptModel> {
    return this._httpClient.delete<TypeConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.typeConcept.DeleteTypeConcept}/${typeConceptId}`);
  }

  getAllTypeConcept(): Observable<Array<TypeConceptModel>> {
    return this._httpClient.get<Array<TypeConceptModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.typeConcept.GetAllTypeConcept}`)
  }

  getColumnsForConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.typeConcept.GetColumnsForConsultation}`);
  }

  getTypeConceptByCode(code: number): Observable<TypeConceptModel> {
    return this._httpClient.get<TypeConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.typeConcept.GetTypeConceptByCode}/${code}`)
  }
  getTypeConceptById(typeConceptId: number): Observable<TypeConceptModel> {
    return this._httpClient.get<TypeConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.typeConcept.GetTypeConceptpById}/${typeConceptId}`)
  }

  getTypeConceptsForConsultation(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<TypeConceptTableModel>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);

    return this._httpClient.post<PagedResponseModel<TypeConceptTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.typeConcept.GetTypeConceptsForConsultation}`,
      filters, { params: params }
    );
  }

  updateTypeConcept(typeConceptModel: TypeConceptModel): Observable<TypeConceptModel> {
    return this._httpClient.put<TypeConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.typeConcept.UpdateTypeConcept}`,
      typeConceptModel);
  }

}
